import authService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("userF"));
const token = localStorage.getItem("auth_token");

const initialState = {
  user: user && typeof user === "object" ? user : null,
  token: token || null,
  loggedIn: !!(user && token),
};

export const auth = {
  namespaced: true,
  state: initialState,

  actions: {
    async login({ commit, dispatch }, userData) {
      try {
        const response = await authService.login(userData);

        if (response.data && response.data.token) {
          const { user, token } = response.data;

          if (user) {
            commit("loginSuccess", { user, token });
            try {
              await dispatch("loadUserPermissions");
            } catch (error) {
              console.warn("No se pudieron cargar los permisos después del login");
            }
          } else {
            commit("loginWithTokenOnly", token);
            try {
              await dispatch("refreshUserInfo");
              await dispatch("loadUserPermissions");
            } catch (error) {
              console.warn("No se pudo obtener información del usuario");
            }
          }
        } else {
          commit("logMeIn");
        }

        return response;
      } catch (error) {
        commit("loginFailure");
        throw error; // CRUCIAL: Relanza el error para que Login.vue active el temporizador 429
      }
    },

    async logout({ commit }) {
      try {
        await authService.logout();
      } catch (error) {
        console.error("Logout error:", error);
      } finally {
        commit("logMeOut");
      }
    },

    async register({ commit }, userData) {
      try {
        const response = await authService.register(userData);

        if (response.data && response.data.user && response.data.token) {
          const { user, token } = response.data;
          commit("loginSuccess", { user, token });
        } else {
          commit("logMeIn");
        }

        return response;
      } catch (error) {
        commit("loginFailure");
        throw error;
      }
    },

    loadUserFromStorage({ commit, dispatch }) {
      const user = JSON.parse(localStorage.getItem("userF"));
      const token = localStorage.getItem("auth_token");

      if (token) {
        if (user && typeof user === "object") {
          commit("loginSuccess", { user, token });
        } else {
          commit("logMeIn");
          dispatch("refreshUserInfo");
        }

        dispatch("loadUserPermissions");
      }
    },

    async refreshUserInfo({ commit, state }) {
      try {
        if (!state.token) return;

        const userData = await authService.refreshUser();
        commit("updateUser", userData);
        return userData;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          commit("logMeOut");
        }
        throw error;
      }
    },

    async loadUserPermissions({ commit, state }) {
      try {
        if (!state.token) return;

        const permissions = await authService.getUserPermissions();
        commit("setUserPermissions", permissions);
        return permissions;
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          commit("logMeOut");
        }
        throw error;
      }
    },

    async updateProfile({ commit }, profileData) {
      const response = await authService.updateProfile(profileData);
      const updatedUser = response.data.user || response.data;

      localStorage.setItem("userF", JSON.stringify(updatedUser));
      commit("updateUser", updatedUser);

      return response;
    },
  },

  mutations: {
    loginSuccess(state, { user, token }) {
      state.loggedIn = true;
      state.user = user;
      state.token = token;
      localStorage.setItem("auth_token", token);
      localStorage.setItem("userF", JSON.stringify(user));
    },

    loginFailure(state) {
      state.loggedIn = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userF");
    },

    logMeIn(state) {
      state.loggedIn = true;
    },

    loginWithTokenOnly(state, token) {
      state.loggedIn = true;
      state.user = null;
      state.token = token;
      localStorage.setItem("auth_token", token);
      localStorage.removeItem("userF");
    },

    logMeOut(state) {
      state.loggedIn = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userF");
    },

    updateUser(state, user) {
      state.user = { ...state.user, ...user };
      localStorage.setItem("userF", JSON.stringify(state.user));
    },

    setToken(state, token) {
      state.token = token;
      localStorage.setItem("auth_token", token);
    },

    setUserPermissions(state, permissions) {
      if (state.user) {
        state.user = { ...state.user, permissions };
        localStorage.setItem("userF", JSON.stringify(state.user));
      }
    },
  },

  getters: {
    loggedIn(state) {
      return state.loggedIn;
    },
    user(state) {
      return state.user || {};
    },
    token(state) {
      return state.token;
    },
    userName(state) {
      return state.user?.name || "";
    },
    userEmail(state) {
      return state.user?.email || "";
    },
    userRole(state) {
      return state.user?.role || "";
    },
    userAvatar(state) {
      return state.user?.avatar || null;
    },
    userInitials(state) {
      if (!state.user?.name) return "U";
      const names = state.user.name.split(" ");
      if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
      }
      return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    },
    userPermissions(state) {
      return state.user?.permissions || {};
    },
    hasPermission: (state) => (permission) => {
      return state.user?.permissions?.[permission] === true;
    },
    hasModuleAccess: (state) => (moduleId) => {
      const permissions = state.user?.permissions || {};
      return permissions[moduleId] === true;
    },
  },
};